import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import * as moment from "moment";

@Injectable({
    providedIn: 'root'
  })
  export class HourFormatService {
    localToUtcHour(date: Date): string { 
      return moment(date).utc().format('HH:mm');
    }
    utcToLocalHour(utcDate: string): string {
        return moment.utc(utcDate).local().format('HH:mm');
    } 
    localToUtc(date: Date){
        var horarioEmUtc = Number(moment.utc(date).local().format('HH'));
        var horarioLocal = Number(date.getHours());
        var diferenca = horarioEmUtc - horarioLocal;
        if(horarioEmUtc<Math.abs(diferenca)){
            return moment(date).add(1, 'days').utc().format();
        }
        return moment(date).utc().format();
    }
    localToUtc2(date: Date|string): string {
      const local = moment(date, 'DD/MM/YYYY HH:mm'); // parse no formato local
    return local.utc().format(); 
    }
    utcTolocal(utcDate: string){
        return moment.utc(utcDate).local().format('DD/MM/YYYY' + ' HH:mm');
    }
    utcTolocalDate(utcDate: string){
        return new Date(moment.utc(utcDate).local().format('MM/DD/YYYY' + ' HH:mm:ss')); 
    }
    utcTolocalDay(utcDate: string){
      return moment.utc(utcDate).local().format('DD/MM/YYYY');
    }
    addDays(startDate: string, days: number): string {
      return moment(startDate).add(days, 'days').utc().format('YYYY-MM-DD');
    }
  }
  
